import { throttle } from 'lodash'
import Cookies from 'js-cookie'
import { TimeConstants } from '@core/Constants'
import { CloudAdapter } from '@/netadapters/CloudAdapter'

const COOKIE_KEY_NAME = 'OCLOUD_OWORK_REFRESH'

export class AuthorTokenManager {
  #adapter = new CloudAdapter()
  #throttleRefresh: () => void

  constructor() {
    this.#throttleRefresh = throttle(
      async () => {
        await this.#adapter.refreshAccessToken()
      },
      TimeConstants.ACCESS_TOKEN_EXPIRED_THRESHOLD_IN_MS,
      {
        leading: true,
        trailing: true,
      }
    )
  }

  isExpired(): boolean {
    const now = Date.now()
    const expirationTime: string | undefined = Cookies.get(COOKIE_KEY_NAME)

    return now >= Number(expirationTime || 0) - TimeConstants.ACCESS_TOKEN_EXPIRED_THRESHOLD_IN_MS
  }

  refresh(): void {
    this.#throttleRefresh()
  }

  /**
   * @deprecated
   * DataSyncManager专用，用于立即刷新，其他模块不得调用此方法
   */
  async syncRefresh(): Promise<boolean> {
    return this.#adapter.refreshAccessToken()
  }
}

export const INSTANCE = new AuthorTokenManager()
